/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    open: {
      description: 'Applies when a ButtonDropdown is open.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    size: { type: 'variant', values: [ 'default', 'small' ] },
    width: { type: 'variant', values: [ 'full' ] }
  },
  rules: [
    { if: { open: true }, tokens: { icon: PaletteIconChevronUp } },
    { if: { focus: true }, tokens: { outerBorderColor: '#000000' } },
    {
      if: { focus: false, hover: true, pressed: false },
      tokens: { backgroundColor: '#404040', borderColor: 'rgba(0, 0, 0, 0)' }
    },
    {
      if: { focus: true, hover: true, pressed: false },
      tokens: { backgroundColor: '#404040', borderColor: 'rgba(0, 0, 0, 0)' }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        borderColor: '#c9c8c8',
        color: '#ffffff',
        iconColor: '#ffffff',
        leadIconColor: '#ffffff'
      }
    },
    {
      if: { hover: true, selected: true },
      tokens: { backgroundColor: '#404040' }
    },
    {
      if: { focus: true, hover: false, selected: true },
      tokens: {
        outerBorderColor: '#000000',
        outerBorderGap: 2,
        outerBorderWidth: 1
      }
    },
    {
      if: { hover: true, pressed: true, selected: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#666666',
        iconColor: '#666666',
        leadIconColor: '#666666'
      }
    },
    {
      if: { focus: true, pressed: true, selected: true },
      tokens: { backgroundColor: '#404040', outerBorderColor: '#404040' }
    },
    {
      if: { hover: true },
      tokens: {
        color: '#ffffff',
        iconColor: '#ffffff',
        leadIconColor: '#ffffff'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: '#404040',
        color: '#666666',
        iconColor: '#666666',
        leadIconColor: '#666666'
      }
    },
    {
      if: { size: 'small' },
      tokens: { paddingBottom: 4, paddingTop: 4 }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: '#000000',
    borderRadius: 4,
    borderWidth: 1,
    color: '#000000',
    descriptionFontName: 'StagSans',
    descriptionFontSize: 14,
    descriptionFontWeight: '400',
    descriptionLineHeight: 1.42857142857,
    descriptionTextPaddingBottom: 0,
    dividerColor: '#c9c8c8',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    icon: PaletteIconChevronDown,
    iconAlignSelf: 'center',
    iconBackground: 'rgba(0, 0, 0, 0)',
    iconBorderRadius: 32,
    iconColor: '#000000',
    iconPadding: 0,
    iconPosition: 'right',
    iconSize: 20,
    iconSpace: 1,
    iconTranslateX: 0,
    iconTranslateY: 0,
    leadIcon: null,
    leadIconBackgroundColor: 'transparent',
    leadIconBorderRadius: 0,
    leadIconColor: '#000000',
    leadIconContainerPaddingBottom: 0,
    leadIconContainerPaddingLeft: 0,
    leadIconContainerPaddingRight: 0,
    leadIconContainerPaddingTop: 0,
    leadIconPadding: 0,
    leadIconSize: 24,
    lineHeight: 1.5,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderWidth: 1,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    shadow: null,
    subtitleColor: '#000000',
    textAlign: 'center',
    textPaddingLeft: 8,
    textPaddingRight: 8,
    width: null
  }
}
export default theme
